var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCredential(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "certificate (2) 1",
    clipPath: "url(#clip0_9643_35185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.9353 0H19.4287C18.6676 0 17.9237 0.165516 17.245 0.476609C16.948 0.612734 16.7564 0.908531 16.7564 1.23509V13.0108C16.7564 14.8057 15.3013 16.2607 13.5064 16.2607H1.7307C1.40396 16.2607 1.10817 16.4524 0.972215 16.7494C0.661121 17.4281 0.495605 18.1722 0.495605 18.9331V82.7578C0.495605 85.653 2.84256 88 5.73779 88H54.9353C57.8305 88 60.1775 85.653 60.1775 82.7578V5.24219C60.1773 2.34695 57.8304 0 54.9353 0Z",
    fill: "url(#paint0_linear_9643_35185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M64.4801 0H53.2236C56.1189 0 58.4658 2.34695 58.4658 5.24219V82.7578C58.4658 85.653 56.1189 88 53.2236 88H64.4801C67.3753 88 69.7223 85.653 69.7223 82.7578V5.24219C69.7223 2.34695 67.3753 0 64.4801 0Z",
    fill: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.03073 15.2281L15.7218 1.53708C16.17 1.08883 16.6912 0.730125 17.2571 0.472656V13.5135C17.2571 15.3084 15.802 16.7635 14.0072 16.7635H0.966309C1.22395 16.1973 1.58248 15.6764 2.03073 15.2281Z",
    fill: "#E28086"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.4919 33.4644H10.4988C9.76541 33.4644 9.1709 32.8699 9.1709 32.1365C9.1709 31.4031 9.76524 30.8086 10.4988 30.8086H44.4919C45.2253 30.8086 45.8198 31.4031 45.8198 32.1365C45.8198 32.8699 45.2253 33.4644 44.4919 33.4644Z",
    fill: "url(#paint1_linear_9643_35185)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.4919 42.7964H10.4988C9.76541 42.7964 9.1709 42.2019 9.1709 41.4685C9.1709 40.7351 9.76524 40.1406 10.4988 40.1406H44.4919C45.2253 40.1406 45.8198 40.7351 45.8198 41.4685C45.8198 42.2019 45.2253 42.7964 44.4919 42.7964Z",
    fill: "url(#paint2_linear_9643_35185)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M44.4919 52.1246H10.4988C9.76541 52.1246 9.1709 51.53 9.1709 50.7967C9.1709 50.0633 9.76524 49.4688 10.4988 49.4688H44.4919C45.2253 49.4688 45.8198 50.0633 45.8198 50.7967C45.8198 51.53 45.2253 52.1246 44.4919 52.1246Z",
    fill: "url(#paint3_linear_9643_35185)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M44.4919 61.4566H10.4988C9.76541 61.4566 9.1709 60.8621 9.1709 60.1287C9.1709 59.3953 9.76524 58.8008 10.4988 58.8008H44.4919C45.2253 58.8008 45.8198 59.3953 45.8198 60.1287C45.8198 60.8621 45.2253 61.4566 44.4919 61.4566Z",
    fill: "url(#paint4_linear_9643_35185)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.5388 75.1285H10.4988C9.76541 75.1285 9.1709 74.534 9.1709 73.8006C9.1709 73.0672 9.76524 72.4727 10.4988 72.4727H27.539C28.2724 72.4727 28.8669 73.0672 28.8669 73.8006C28.8669 74.534 28.2724 75.1285 27.5388 75.1285Z",
    fill: "url(#paint5_linear_9643_35185)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M75.3733 77.9734L70.5036 74.9755C70.0244 74.6806 69.4201 74.6806 68.9409 74.9755L64.0712 77.9734C63.0781 78.5847 61.7993 77.8702 61.7993 76.7041V57.418H77.6452V76.7041C77.6452 77.8702 76.3664 78.5847 75.3733 77.9734Z",
    fill: "#E8AE4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M66.5437 64.527C72.7118 61.3035 76.9093 54.941 76.9093 47.619C76.9093 40.2969 72.712 33.9345 66.5437 30.7109C65.5387 31.9782 63.8649 32.5125 62.3092 32.0586C59.809 31.329 57.293 33.1569 57.2143 35.7603C57.1648 37.3962 56.1195 38.835 54.579 39.3875C52.1273 40.2668 51.1664 43.2246 52.6328 45.377C53.5542 46.7295 53.5542 48.5081 52.6328 49.8606C51.1662 52.013 52.1273 54.9708 54.579 55.8501C56.1195 56.4026 57.1648 57.8416 57.2143 59.4773C57.293 62.0807 59.809 63.9086 62.3092 63.179C63.8649 62.7254 65.5387 63.2599 66.5437 64.527Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M86.8117 49.8613C85.8903 48.5088 85.8903 46.7302 86.8117 45.3778C88.2782 43.2254 87.3172 40.2677 84.8656 39.3883C83.3251 38.8357 82.2797 37.3967 82.2302 35.761C82.1515 33.1576 79.6356 31.3297 77.1353 32.0593C75.5642 32.5177 73.8728 31.9681 72.8711 30.6738C71.2772 28.6139 68.1674 28.6139 66.5735 30.6738C66.349 30.964 66.0898 31.2166 65.8052 31.4289C71.9514 34.2287 76.2239 40.4252 76.2239 47.6197C76.2239 54.8142 71.9513 61.0106 65.8052 63.8105C66.0898 64.0228 66.349 64.2754 66.5735 64.5655C68.1674 66.6255 71.2772 66.6255 72.8711 64.5655C73.8726 63.2711 75.5642 62.7217 77.1353 63.18C79.6356 63.9097 82.1515 62.0818 82.2302 59.4784C82.2797 57.8425 83.3251 56.4037 84.8656 55.8511C87.3172 54.9713 88.2782 52.0137 86.8117 49.8613Z",
    fill: "#FFD064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M69.7221 57.4188C75.1351 57.4188 79.5232 53.0306 79.5232 47.6176C79.5232 42.2045 75.1351 37.8164 69.7221 37.8164C64.309 37.8164 59.9209 42.2045 59.9209 47.6176C59.9209 53.0306 64.309 57.4188 69.7221 57.4188Z",
    fill: "#E8AE4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M79.5231 47.6184C79.5231 43.677 77.1965 40.2788 73.8418 38.7227C75.3565 41.3393 76.2235 44.3777 76.2235 47.6184C76.2235 50.8593 75.3564 53.8977 73.8418 56.5141C77.1966 54.958 79.5231 51.56 79.5231 47.6184Z",
    fill: "#E5A32E"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M2.03073 15.2281L15.7218 1.53708C16.17 1.08883 16.6912 0.730125 17.2571 0.472656V13.5135C17.2571 15.3084 15.802 16.7635 14.0072 16.7635H0.966309C1.22395 16.1973 1.58248 15.6764 2.03073 15.2281Z",
    fill: "url(#paint6_linear_9643_35185)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9643_35185",
    x1: 0.687088,
    y1: 37.8459,
    x2: 63.664,
    y2: 52.3729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9643_35185",
    x1: -27.865,
    y1: 33.7066,
    x2: 46.2068,
    y2: 33.7066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9643_35185",
    x1: -27.865,
    y1: 43.0386,
    x2: 46.2068,
    y2: 43.0386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9643_35185",
    x1: -27.865,
    y1: 52.3668,
    x2: 46.2068,
    y2: 52.3668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9643_35185",
    x1: -27.865,
    y1: 61.6988,
    x2: 46.2068,
    y2: 61.6988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9643_35185",
    x1: -10.7331,
    y1: 75.3707,
    x2: 29.0749,
    y2: 75.3707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9643_35185",
    x1: 0.966489,
    y1: 8.61807,
    x2: 17.2571,
    y2: 8.61807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9643_35185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCredential);
export default __webpack_public_path__ + "static/media/noCredential.26789936ebb588db667659dad70c7a3e.svg";
export { ForwardRef as ReactComponent };